import React from 'react';

const stiahniSubor = (nazov, mime, obsah) => {
  const blob = new Blob([obsah], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nazov;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

 export function useExporterySplatkovyKalendar({
  skalRezim,
  splatkovyKalendar,
  aggrRocne,
  splatkovyKalendarPS_skratenie,
  splatkovyKalendarPS_znizenie,
  investicnyPriebeh,
  investRocne,
  zCentovNaCeleEura,
  ppOpen,
  ppClamped,
  ppRezim,
}) {
  const refTabulka = React.useRef(null);

  const zostavData = () => {
    const jeMesiace = skalRezim === 'mesiace';
    const baseM = splatkovyKalendar;
    const baseR = aggrRocne(splatkovyKalendar);

    const psS = splatkovyKalendarPS_skratenie;
    const psZ = splatkovyKalendarPS_znizenie;

    const invM = investicnyPriebeh?.graf || [];
    const invR = investRocne(invM);

    const payoffPS = ppRezim === 'skratenie'
      ? (psS?.find((r) => (r.zostatokC ?? Infinity) <= 0)?.mesiac ?? null)
      : (psZ?.find((r) => (r.zostatokC ?? Infinity) <= 0)?.mesiac ?? null);

    const hlavicky = [
      jeMesiace ? 'Mesiac' : 'Rok',
      'Splatka',
      'Istina',
      'Urok',
      'Zostatok',
    ];

    const zobrazPS = !!(ppOpen && ppClamped?.events?.length);
    if (zobrazPS && ppRezim === 'znizenie') hlavicky.push('S PS splatka');
    if (zobrazPS) hlavicky.push('S PS zostatok');

    const zobrazInv = !!investicnyPriebeh;
    if (zobrazInv) hlavicky.push('Investicia');

    const riadky = [];

    if (jeMesiace) {
      baseM.forEach((r, i) => {
        const i1 = i + 1;
        const psRadokS = psS?.[i] || null;
        const psRadokZ = psZ?.[i] || null;
        const invVal = invM[i] ?? null;

        const row = [
          i1,
          `${zCentovNaCeleEura(r.splatkaC)}`,
          `${zCentovNaCeleEura(r.splatkaC) - zCentovNaCeleEura(r.urokC)}`,
          `${zCentovNaCeleEura(r.urokC)}`,
          `${zCentovNaCeleEura(r.zostatokC)}`,
        ];

        if (zobrazPS && ppRezim === 'znizenie') {
          row.push(psRadokZ ? `${zCentovNaCeleEura(psRadokZ.splatkaC)}` : '');
        }
        if (zobrazPS) {
          const zc = (ppRezim === 'skratenie' ? psRadokS?.zostatokC : psRadokZ?.zostatokC);
          row.push(zc != null ? `${zCentovNaCeleEura(zc)}` : (payoffPS === i1 ? '0' : ''));
        }
        if (zobrazInv) {
          row.push(invVal != null ? `${Math.round(invVal)}` : '');
        }

        riadky.push(row);
      });
    } else {
      baseR.forEach((r, idx) => {
        const i0 = idx * 12;
        const i11 = i0 + 11;

        const psSslice = psS?.slice(i0, i11 + 1) || [];
        const psZslice = psZ?.slice(i0, i11 + 1) || [];

        const psSZostatok = psSslice.length ? psSslice[psSslice.length - 1].zostatokC : null;
        const psZZostatok = psZslice.length ? psZslice[psZslice.length - 1].zostatokC : null;

        const invRiadok = invR.find(x => x.rok === (idx + 1));

        const row = [
          idx + 1,
          `${zCentovNaCeleEura(r.splatkaC)}`,
          `${zCentovNaCeleEura(r.istinaC)}`,
          `${zCentovNaCeleEura(r.urokC)}`,
          `${zCentovNaCeleEura(r.zostatokC)}`,
        ];

        if (zobrazPS && ppRezim === 'znizenie') {
          row.push(''); 
        }
        if (zobrazPS) {
          const zc = ppRezim === 'skratenie' ? psSZostatok : psZZostatok;
          row.push(zc != null ? `${zCentovNaCeleEura(zc)}` : '');
        }
        if (zobrazInv) {
          row.push(invRiadok ? `${Math.round(invRiadok.hodnota)}` : '');
        }

        riadky.push(row);
      });
    }

    return { hlavicky, riadky, jeMesiace };
  };

  const exportujCSV = () => {
    const { hlavicky, riadky, jeMesiace } = zostavData();
    const head = hlavicky.join(';');
    const body = riadky.map(r => r.join(';')).join('\n');
    const csv = `${head}\n${body}`;
    stiahniSubor(`splatkovy_kalendar_${jeMesiace ? 'mesiace' : 'roky'}.csv`, 'text/csv;charset=utf-8', csv);
  };

  const exportujPDF = () => {
    const { hlavicky, riadky, jeMesiace } = zostavData();

    const win = window.open('', '_blank', 'width=1024,height=768');
    if (!win) return;

    const escapeHtml = (value) =>
      String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');

    const thead = `
      <thead>
        <tr>
          ${hlavicky.map((h, idx) => `<th${idx === 0 ? ' style="text-align:left"' : ''}>${escapeHtml(h)}</th>`).join('')}
        </tr>
      </thead>
    `;

    const tbody = `
      <tbody>
        ${riadky.map((riadok) => `
          <tr>
            ${riadok.map((cell, idx) => `<td${idx === 0 ? ' style="text-align:left"' : ''}>${escapeHtml(cell)}</td>`).join('')}
          </tr>
        `).join('')}
      </tbody>
    `;

    win.document.write(`
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Splátkovy kalendar</title>
          <style>
            body { font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif; padding: 16px; color: #111; }
            h1 { font-size: 16px; margin: 0 0 12px; }
            table { width: 100%; border-collapse: collapse; font-size: 12px; }
            th, td { border: 1px solid #ddd; padding: 4px 6px; text-align: center; }
            th { background: #f3f4f6; }
            td:first-child, th:first-child { text-align: left; }
          </style>
        </head>
        <body>
          <h1>Splátkovy kalendar – ${jeMesiace ? 'mesiace' : 'roky'}</h1>
          <table>
            ${thead}
            ${tbody}
          </table>
        </body>
      </html>
    `);

    win.document.close();
    win.focus();
    win.print();
  };

  return { exportujCSV, exportujPDF, refTabulka };
}